import * as Three from 'three';
import React from 'react';

export default {
    name: 'circular-stairs',
    prototype: 'items',

    info: {
        tag: ['metal'],
        title: 'Circular stairs',
        description: 'Circular stairs',
        image: require('./circular-stairs.jpg')
    },

    properties: {
        // altitude: {
        //     label: 'altitude',
        //     type: 'length-measure',
        //     defaultValue: {
        //         length: 0,
        //         unit: 'cm'
        //     }
        // },
        width: {
            label: 'width',
            type: 'length-measure',
            defaultValue: {
                length: 130,
                unit: 'cm'
            }
        },
    },

    render2D: function (element, layer, scene) {

        let styleCircle = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "transparent" };
        let style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" };
        let width = element.properties.get('width').get('length');
        let lines = [];
        let x = 0;
        let y = width;
        let step = 60;
        for (let i = 0; i < (width * 3) / step; i++) {
            if (x === 0 && y > 0 && y <= width) {
                if (y - step > 0) {
                    y -= step;
                }
                else {
                    y = 0;
                    x -= (y - step);
                }
            }
            else if (x > 0 && x <= width && y === 0) {
                if (x + step < width) {
                    x += step;
                }
                else {
                    y += (x + step) - width;
                    x = width;
                }
            }
            else if (x === width && y > 0) {
                if (y + step < width) {
                    y += step;
                }
                else {
                    y = width;
                    x += (y - step) - width;
                }
            }
            lines.push({ x: x, y: y });
        }

        let firstpoint = {
            x: width / 2 + (lines[0].x - width / 2) / 2,
            y: width / 2 + (lines[0].y - width / 2) / 2
        }

        let lastpoint = {
            x: width / 2 + (lines[lines.length - 1].x - width / 2) / 2,
            y: width / 2 + (lines[lines.length - 1].y - width / 2) / 2
        }

        return (
            <g transform={`translate(${-width / 2},${-width / 2})`}>
                <rect key="1" x='0' y='0' width={width} height={width} style={style} />
                <path key="2"
                    d={`M ${firstpoint.x} ${firstpoint.y} A ${width / 3.6} ${width / 3.6}, 0, 1, 1, ${lastpoint.x} ${lastpoint.y}`}
                    style={styleCircle}
                />
                {lines.map((line, index) =>
                    <line key={index + 6} x1={width / 2} y1={width / 2} x2={line.x} y2={line.y} stroke={element.selected ? '#000' : '#777'} strokeWidth="2" />
                )}
                <circle key="3" cx={width / 2} cy={width / 2} r={10} style={style} />
                <circle key="4" cx={width / 2 + (lines[0].x - width / 2) / 2} cy={width / 2 + (lines[0].y - width / 2) / 2} r={5} style={style} />
                <line key="5" x1={lastpoint.x} y1={lastpoint.y} x2={lastpoint.x + 10} y2={lastpoint.y - 20} stroke={element.selected ? '#000' : '#777'} strokeWidth="2" />
                <line key="6" x1={lastpoint.x} y1={lastpoint.y} x2={lastpoint.x + 20} y2={lastpoint.y + 5} stroke={element.selected ? '#000' : '#777'} strokeWidth="2" />
            </g>
        )
    },


    render3D: function (element, layer, scene) {
        let mesh = new Three.Mesh();
        return Promise.resolve(mesh);
    }
};
